const UNAUTHORIZED = 401;
const FORBIDDEN = 403;

const NOT_FOUND = 404;

const REQUEST_TIMEOUT = 408;
const TOO_MANY_REQUEST = 429;
const SERVICE_UNAVAILABLE = 503;

export {
  UNAUTHORIZED,
  FORBIDDEN,
  NOT_FOUND,
  REQUEST_TIMEOUT,
  TOO_MANY_REQUEST,
  SERVICE_UNAVAILABLE,
};
